var _rect, _path, _path2, _rect2, _path3, _rect3, _rect4, _rect5, _path4, _polygon, _polygon2, _rect6, _rect7, _path5, _path6, _path7, _path8, _polygon3, _polygon4, _path9, _path10, _path11, _circle, _polygon5, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 938.94952,
    height: 517.98015,
    viewBox: "0 0 938.94952 517.98015",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 332.85372,
    y: 513.66655,
    width: 606.0958,
    height: 2,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M921.05069,543.28036c13.25,18.73,16.75,125.33,17.53,159.5.01995.77.04,1.5.05,2.19h33.54c.41-.73.79-1.45,1.15-2.19,19.88-39.24,8.85-86.29,8.27-88.67,1.50994,7.48-5.32,29.16-13.04,50.16C963.84073,599.70035,923.57071,546.54037,921.05069,543.28036Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.03705,288.03355a48.51181,48.51181,0,0,1,0-97.02362H620.56482a48.51181,48.51181,0,0,1,0,97.02362Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.68018,
    y: 6.32763,
    width: 86.36017,
    height: 84.36837,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M620.56482,197.33755h-44.645v84.36837h44.645a42.18418,42.18418,0,1,0,0-84.36837Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 270.33021,
    y: 6.32763,
    width: 85.77451,
    height: 84.36837,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182.44649,
    y: 6.32763,
    width: 86.47758,
    height: 84.36837,
    fill: "#63ffc2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 357.51085,
    y: 6.32763,
    width: 86.47758,
    height: 84.36837,
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.79928,197.33755H179.037a42.18418,42.18418,0,1,0,0,84.36837h44.76224Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#63ffc2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "45.408 64.735 33.663 49.636 40.493 44.323 46.053 51.473 64.839 31.644 71.12 37.595 45.408 64.735",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.363 64.735 206.618 49.636 213.448 44.323 219.008 51.473 237.794 31.644 244.075 37.595 218.363 64.735",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 527.83156,
    y: 221.01568,
    width: 5.5092,
    height: 37.0121,
    transform: "translate(-144.4876 254.32544) rotate(-45)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 513.45755,
    y: 236.76713,
    width: 37.0121,
    height: 5.5092,
    transform: "translate(-144.08415 255.29944) rotate(-45)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.21618,264.81564a25.31051,25.31051,0,1,1,25.31051-25.31051A25.33906,25.33906,0,0,1,268.21618,264.81564Zm0-44.99646a19.686,19.686,0,1,0,19.68595,19.686A19.70807,19.70807,0,0,0,268.21618,219.81918Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M443.98361,264.81564a25.31051,25.31051,0,1,1,25.31051-25.31051A25.33906,25.33906,0,0,1,443.98361,264.81564Zm0-44.99646a19.686,19.686,0,1,0,19.68595,19.686A19.70807,19.70807,0,0,0,443.98361,219.81918Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M619.048,264.81564a25.31051,25.31051,0,1,1,25.31051-25.31051A25.33906,25.33906,0,0,1,619.048,264.81564Zm0-44.99646a19.686,19.686,0,1,0,19.686,19.686A19.70807,19.70807,0,0,0,619.048,219.81918Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M851.38353,464.45242l-10.62585,29.64052a10.34739,10.34739,0,0,0,4.37745,12.341l0,0a10.34739,10.34739,0,0,0,15.64572-7.69444l3.37227-30.03053,25.53922-84.42132L867.70025,373.6463Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "711.991 497.265 727.598 497.265 727.598 345.449 692.127 344.739 711.991 497.265",
    fill: "#a0616a"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "642.467 497.265 658.074 497.265 658.074 345.449 622.603 344.739 642.467 497.265",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M860.606,552.42086l-40.43711-4.25654-8.51307-44.69364-15.60731,45.40306-48.24075-4.966L767.67163,468.709c36.30995-24.67316,70.79615-24.13361,103.57574,0Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M792.04624,694.741a12.67411,12.67411,0,0,1-14.27955,14.13116l-28.75209-3.89946a9.82627,9.82627,0,0,1-8.19677-11.2029v0a9.82627,9.82627,0,0,1,9.712-8.33211h4.74057l15.5969-14.21051c.15379,9.67931,7.2821,7.52995,19.06287,6.58536Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M861.56968,694.741a12.67411,12.67411,0,0,1-14.27955,14.13116L818.538,704.97268a9.82627,9.82627,0,0,1-8.19677-11.2029v0a9.82627,9.82627,0,0,1,9.712-8.33211h4.74057l15.5969-14.21051c.15379,9.67931,7.2821,7.52995,19.06287,6.58536Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 675.63258,
    cy: 78.17385,
    r: 25.00716,
    fill: "#a0616a"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "707.379 120.207 676.165 123.045 676.165 95.377 692.481 85.445 707.379 120.207",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M874.79448,479.3503c-31.40278-22.99491-69.10967-20.65841-110.67-2.83769,18.82984-53.30557,26.85059-102.985,12.06018-145.01157a33.436,33.436,0,0,1,25.14947-32.39292l5.35572-1.37007,26.24864,1.41884,24.64823,14.449A33.555,33.555,0,0,1,874.172,342.40115Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#63ffc2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M753.48317,458.777l-10.62584,29.64052a10.34738,10.34738,0,0,0,4.37744,12.341h0a10.34738,10.34738,0,0,0,15.64571-7.69443l3.37227-30.03053L791.792,378.61226,769.7999,367.97091Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M895.36775,400.60436H860.606V315.47362h0a47.95711,47.95711,0,0,1,23.64788,32.08749Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#63ffc2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M787.09191,255.64389a10.18217,10.18217,0,0,1-9.66538-.523,7.705,7.705,0,0,1-3.07332-8.83245c1.0544-2.71107,3.72255-4.40874,6.31141-5.73513a63.70442,63.70442,0,0,1,18.15276-6.06395c3.014-.52152,6.20577-.8082,9.0545.30589,1.40954.55125,2.67346,1.42439,4.07257,2.00156,2.57261,1.06127,5.44252,1.06591,8.16522,1.64159A19.92323,19.92323,0,0,1,833.345,248.3547a24.00724,24.00724,0,0,1,2.04864,5.3776,30.94533,30.94533,0,0,1-.04985,15.57471c-2.14128,8.08308-7.59126,15.50989-7.10076,23.85741-4.02949-2.34645-5.917-7.1238-9.2818-10.352a15.2743,15.2743,0,0,0-9.18029-4.158,4.85548,4.85548,0,0,1-2.68043-.68249,4.18309,4.18309,0,0,1-1.166-2.10784l-3.79068-11.87319c-.77146-2.41636-1.70321-5.0417-3.8836-6.33781a9.77178,9.77178,0,0,0-4.33638-1.05378,66.02557,66.02557,0,0,0-10.82686.10171",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M795.33912,384.99706l-40.4371-15.6073,18.36389-49.48047a31.94213,31.94213,0,0,1,27.74857-20.75239h0Z",
    transform: "translate(-130.52524 -191.00993)",
    fill: "#63ffc2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomization);
export default __webpack_public_path__ + "static/media/customization.19432f20.svg";
export { ForwardRef as ReactComponent };